import { almostZero } from "@xola/ui-kit";
import { getPaymentLineItems, isPartnerPackageProduct, PurchaseItemStatus } from "common";
import { Product, Purchase, PurchaseItemObject } from "types";
import { useResource } from "../../hooks/useResource";
import { isPackage } from "../../models/Purchase";
import { RefundOption } from "./RefundOption";

export const useRefundOptions = (purchase: Purchase) => {
    const item = purchase.items[0];
    const parentProductId = item?.parentProduct?.id;
    const { data: parentProduct } = useResource<Product>(["products", parentProductId], {
        isEnabled: !!parentProductId,
    });
    const hasPaymentMethod = getPaymentLineItems(purchase).length > 0;
    const hasAnyExperienceItems = purchase.items.some(
        (item) => item.object === PurchaseItemObject.EXPERIENCE || item.object === PurchaseItemObject.ORDER,
    );
    const hasAnyMerchandiseItems = purchase.items.some((item) => item.object === PurchaseItemObject.WARE);

    const hasAnyEquipmentItems = purchase.items.some((item) => item.object === PurchaseItemObject.EQUIPMENT);

    let refundOption: RefundOption;
    let showChangeGuestOption;
    let showChangeMerchandiseOption;
    let showChangeEquipmentOption;

    if (isPackage(parentProduct) || isPartnerPackageProduct(parentProduct)) {
        refundOption =
            hasPaymentMethod && almostZero(purchase?.balance) ? RefundOption.REDUCE_AND_RETURN : RefundOption.REDUCE;
        showChangeGuestOption = ![PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
        showChangeMerchandiseOption =
            hasAnyMerchandiseItems && ![PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
        showChangeEquipmentOption =
            hasAnyEquipmentItems && ![PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
    } else {
        refundOption =
            purchase.balance > 0 || purchase.splitPayment.enabled
                ? RefundOption.REDUCE
                : RefundOption.REDUCE_AND_RETURN;
        showChangeGuestOption =
            hasAnyExperienceItems &&
            !purchase.items.some((item) => {
                return [PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
            });
        showChangeMerchandiseOption =
            hasAnyMerchandiseItems &&
            !purchase.items.some((item) => {
                return [PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
            });
        showChangeEquipmentOption =
            hasAnyEquipmentItems &&
            !purchase.items.some((item) => {
                return [PurchaseItemStatus.CANCELED, PurchaseItemStatus.DECLINED].includes(item.status);
            });
    }

    let options: RefundOption[] = [refundOption];

    if (hasPaymentMethod) {
        options = [...options, RefundOption.RETURN_PAYMENT];
    }

    if (showChangeGuestOption) {
        options = [...options, RefundOption.CHANGE_GUEST_QUANTITY];
    }

    if (showChangeMerchandiseOption) {
        options = [...options, RefundOption.CHANGE_MERCHANDISE_QUANTITY];
    }

    if (showChangeEquipmentOption) {
        options = [...options, RefundOption.CHANGE_EQUIPMENT_QUANTITY];
    }

    return options;
};
